import './text.css';
import React, { FC, useEffect, useRef, useState } from 'react';
import { ChatLogDataModel } from '../../../../models/chat-log-data.model';
import EditIcon from '../../../../assets/images/pencil_l.svg';
import DeleteIcon from '../../../../assets/images/student-input/delete_m.svg';
import SendIcon from '../../../../assets/images/student-input/Send.svg';
import SendActiveIcon from '../../../../assets/images/student-input/Send_Active.svg';
import UseOutsideClick from '../../../../hooks/UseOutsideClick';
import Tick from '../../../../assets/images/owner_tick_s.svg';
import { Font } from '../../../../models/font.model';
import { useParams } from 'react-router-dom';
import { StudentStatus } from '../../../../models/student-status.model';
import { DraggableElement } from '../../../../models/draggable-element.model';
import { PARENT_TYPE_CONSTANTS } from '../../../../constants/parentTypeConstants';
export interface IProps {
    parentType:string;
    mode:string;
    component: ChatLogDataModel;
    updateText: (text: string, id: string) => void;
    handleDelete: () => void;
    handleClick: (item: ChatLogDataModel) => void;
    currentComponent: boolean;
    handleClickParent: (item: DraggableElement) => void;
    studentStatusList: StudentStatus[];
    triggerStudentInput?: boolean;
    focusList: string[];
    handleReleaseFocus?: () => void;
    currentItem: DraggableElement | null;
    currentChatLog: ChatLogDataModel | null;
    colorList: any;
    isWorksheetLocked: boolean;
}
const Text: FC<IProps> = ({
    parentType,
    mode,
    component,
    handleClick,
    handleDelete,
    updateText,
    currentComponent,
    handleClickParent,
    studentStatusList,
    triggerStudentInput,
    focusList,
    handleReleaseFocus,
    currentItem,
    currentChatLog,
    colorList,
    isWorksheetLocked
}) => {
    const params = useParams<{ id?: string; sheetId?: string; token?: string }>();
    const { token } = params;
    const [editText, setEditText] = useState<boolean>(false);
    const isLocked = useRef<boolean>(false);
    const isMe = useRef<boolean>(false);

    const [selectedId, setSelectedId] = useState<boolean>(false);

    const [activeStudentData, setActiveStudentData] = useState<any>({ name: '', color: '' });
    const [componentColor, setComponentColor] = useState<string>('black');
    const textRef = useRef<HTMLDivElement>(null);
    const btnRef = useRef<HTMLImageElement>(null);

    const handleTextEdit = () => {
        setEditText(true);
        if (textRef.current) {
            textRef.current.classList.remove('cursor');
            textRef.current.focus();
        }
    };

    const uploadText = () => {
        const textValue = textRef.current?.textContent;
        if (textValue && editText && currentItem) {
            console.log('data will sent', textValue);
            updateText(textValue, currentItem.id);
        }
        setEditText(false);
    };

    const conditionAdded = () => {
        console.log(isLocked.current, isMe.current);
        console.log('conditionAdded:', isLocked.current || isMe.current);
        console.log('currentChatlog', component.data.text);
        console.log(currentChatLog?.id, component.id);
        return ((isLocked.current || isMe.current) && selectedId);
    };

    const getBorder = () => {
        if ((isLocked.current || isMe.current) && selectedId) {
            return activeStudentData.color;
        } else if (currentChatLog && currentChatLog.id === component.id) {
            return '2px solid #4A9BFF';
        } else {
            return '';
        }
    };

    const setValueForIsLocked = (value: boolean) => {
        isLocked.current = value;
    };

    const setValueForActiveStudentData = (obj: any) => {
        setActiveStudentData(obj);
    };

    const setValueForIsMe = (value: boolean) => {
        isMe.current = value;
    };

    UseOutsideClick(textRef,()=>setEditText(false));

    useEffect(() => {
        console.log('Student input text:', component);
        const selectedId = studentStatusList.map((studentStatus: StudentStatus) => studentStatus.componentId);

        setValueForIsLocked(false);
        setValueForIsMe(false);


        const index = selectedId.indexOf(component.id);
        let selected = false;
        if (index > -1) {
            selected = true;
        } else {
            selected = false;
        }

        const focusByMeIndex = studentStatusList.findIndex((studentStatus: StudentStatus) =>
            studentStatus.userAction === 'focus' && studentStatus.componentId === component.id && studentStatus.tabID === sessionStorage.tabID);
        let focusComponenetByMe = '0';
        if (focusByMeIndex > -1)
            focusComponenetByMe = studentStatusList[focusByMeIndex].componentId;
        if (selected) {
            // handleClickParent(currentItem);
            console.log('selected:', component.id);
            studentStatusList.map((studentStatus: StudentStatus) => {
                if (studentStatus.componentId == component.id) {
                    if (studentStatus.userAction === 'focus') {
                        // handleClickParent(currentItem);
                        if (focusComponenetByMe !== studentStatus.componentId) {
                            console.log('focus by other');
                            setSelectedId(true);
                            setValueForIsLocked(true);
                            setValueForIsMe(false);
                            //search color
                            const index = colorList.findIndex((item: any) =>
                                item.tabID === studentStatus.tabID
                            );
                            if (index > -1) {
                                const color = colorList[index].color;
                                setComponentColor(color);
                                setValueForActiveStudentData({ name: studentStatus.username, color: `2px solid ${color}` });
                            } else {
                                const color = '#28AAE1';
                                setComponentColor(color);
                                setValueForActiveStudentData({ name: studentStatus.username, color: `2px solid ${color}` });
                            }
                            console.log('name', studentStatus.username);
                            console.log('active:', activeStudentData);
                            console.log('component color', componentColor);
                            console.log('isLocked:', isLocked.current);
                            console.log('isMe:', isMe.current);
                        } else if (focusComponenetByMe === studentStatus.componentId && studentStatus.tabID !== sessionStorage.tabID) {
                            console.log('focus by me and other');
                            // place logic here
                            if (studentStatus.tabID > sessionStorage.tabID) {
                                console.log('else release');
                                if (handleReleaseFocus)
                                    handleReleaseFocus();
                                setSelectedId(true);
                                setValueForIsLocked(true);
                                setValueForIsMe(false);
                                //search color
                                const index = colorList.findIndex((item: any) =>
                                    item.tabID === studentStatus.tabID
                                );
                                if (index > -1) {
                                    const color = colorList[index].color;
                                    setComponentColor(color);
                                    setValueForActiveStudentData({ name: studentStatus.username, color: `2px solid ${color}` });
                                } else {
                                    const color = '#28AAE1';
                                    setComponentColor(color);
                                    setValueForActiveStudentData({ name: studentStatus.username, color: `2px solid ${color}` });
                                }

                            } else {
                                console.log('else else release');
                                setValueForIsLocked(false);
                                setValueForIsMe(false);
                                setValueForActiveStudentData({ name: '', color: 'release' });
                            }
                        } else if (focusComponenetByMe === studentStatus.componentId && studentStatus.tabID == sessionStorage.tabID) {
                            console.log('focus by me and only');
                            //search color
                            const index = colorList.findIndex((item: any) =>
                                item.tabID === studentStatus.tabID
                            );
                            console.log('index:', index);
                            if (index > -1) {
                                const color = colorList[index].color;
                                setComponentColor(color);
                                console.log('index and color :', color);
                                setValueForActiveStudentData({ name: 'You', color: `2px solid ${color}` });
                                setValueForIsLocked(false);
                                setValueForIsMe(true);
                                setSelectedId(true);
                            } else {
                                const color = '#28AAE1';
                                setComponentColor(color);
                                setValueForActiveStudentData({ name: studentStatus.username, color: `2px solid ${color}` });
                                setValueForIsLocked(false);
                                setValueForIsMe(true);
                                setSelectedId(true);
                            }
                            console.log('student name :', studentStatus.username);
                            console.log('active:', activeStudentData);
                            console.log('isLocked:', isLocked.current);
                            console.log('isMe:', isMe.current);
                        }
                    } else if (studentStatus.userAction === 'submit') {
                        if (studentStatus.tabID !== sessionStorage.tabID) {
                            console.log('submit by other then reload');
                            setValueForIsLocked(false);
                            setValueForIsMe(false);
                            setValueForActiveStudentData({ name: '', color: 'submit' });
                            // if (handleStudentInputUpdate)
                            //     handleStudentInputUpdate(component.id);
                        }
                    }
                }
            });
        } else {
            console.log('not current component');
            setValueForIsLocked(false);
            setValueForIsMe(false);
            setSelectedId(false);
        }

    }, [studentStatusList, triggerStudentInput, focusList]);

    // listen to combination of command key and enter key event to call uploadText
    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.keyCode === 13 && event.metaKey) {
                //
                setEditText(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);


    return (
        <div className='chat-element-wrapper text'
            key={component.id}
            data-component-id={component.id}
            data-id={component.id}
            style={{
                border: getBorder(),
                opacity: isLocked ? 1 : 0.99
            }}>
            <div id="edit-textbox" style={{
                opacity: isMe ? 1 : 0.99
            }}>
                
                
                <div onClick={() => !token && !isWorksheetLocked && !isLocked.current && handleClick(component)}
                    className="auto-resize-textbox cursor bg-s10"
                    id={component.id}
                    ref={textRef}
                    contentEditable={editText}
                    suppressContentEditableWarning={true} tabIndex={-1}

                >{component.data.text}</div>
                {((parentType === PARENT_TYPE_CONSTANTS.viewSubmission && mode === 'collab') || (mode === 'collab' && (currentChatLog && currentChatLog.id === component.id))) && 
                <div className="owner ">
                    <img src={Tick} alt="tick" />
                    <span className='text-c50'>Added by&nbsp;</span>
                    <span className='text-c75'>{component.studentName}</span>
                </div>}
                
                {editText && <img ref={btnRef} src={SendActiveIcon} className="send" id="send-icon" onClick={uploadText} />}
            </div>

            {
                currentChatLog && currentChatLog.id == component.id && <div className="chat-tool-wrapper">
                    <img src={EditIcon} alt="" className='cursor' onClick={handleTextEdit} style={{
                        margin: '4px 6px 4px 0px'
                    }} />
                    <img src={DeleteIcon} alt="" className='cursor' onClick={handleDelete} style={{
                        margin: '4px 0px 4px 6px'
                    }} />
                </div>
            }
            {
                conditionAdded() && <div className="lock-user body-m text-s0"
                    style={{
                        background: componentColor
                    }}>
                    {activeStudentData.name}
                </div>
            }

        </div >
    );
};

export default Text;